import { defineComponent as _defineComponent } from 'vue'
import {
  EProductTypes,
  IProductHero,
  IProductHeroButtonAction
} from '@/modules/catalog/services/products';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ButtonPrimary } from '@warrenbrasil/nebraska-web';
import { PropType, ref } from 'vue';
import { useRouter } from 'vue-router/composables';
import { ContinueRegistrationModal } from '@/modules/common/components/ContinueRegistrationModal';
import { ImpersonateEducationalModal } from '@/modules/common/components/ImpersonateEducationalModal';
import { isImpersonate } from '@/modules/common/services/partner';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductSideSheetActionBar',
  props: {
  showHeaderText: Boolean,
  color: {
    type: String,
    default: ''
  },
  hero: {
    type: Object as PropType<IProductHero>,
    default: null
  },
  productApiId: {
    type: String,
    default: ''
  },
  stopInvestment: Boolean,
  categorySelectedProduct: {
    type: String,
    default: ''
  }
},
  emits: [
  'open-stop-investment-bar',
  'add-product',
  'remove-product'
],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter();





const isButtonLoading = ref(false);
const isContinueRegistrationModalOpen = ref(false);
const isImpersonateEducationalModalOpen = ref(false);
const pendingAction = ref<IProductHeroButtonAction | null>(null);

const updateLoading = (value: boolean) => {
  isButtonLoading.value = value;
};

async function handleClick(action: IProductHeroButtonAction) {
  if (props.stopInvestment) {
    emit('open-stop-investment-bar');
    return;
  }

  if (action === IProductHeroButtonAction.ADD) {
    updateLoading(true);
    emit('add-product', props.productApiId);
    return;
  }

  if (action === IProductHeroButtonAction.REMOVE) {
    updateLoading(true);
    emit('remove-product', props.productApiId);
    return;
  }

  if (action === IProductHeroButtonAction.CONTINUE_REGISTRATION) {
    isContinueRegistrationModalOpen.value = true;
    return;
  }

  // Check if user is impersonating before navigating to investment
  if (
    action === IProductHeroButtonAction.INVEST ||
    action === IProductHeroButtonAction.CHOICE
  ) {
    if (isImpersonate()) {
      pendingAction.value = action;
      isImpersonateEducationalModalOpen.value = true;
      return;
    }
  }

  proceedToInvestment(action);
}

function proceedToInvestment(action: IProductHeroButtonAction) {
  const allowedCategories = [
    EProductTypes.FIXED_INCOME,
    EProductTypes.GOVERNMENT_BOND,
    EProductTypes.FUNDS
  ];

  const category = props.categorySelectedProduct as EProductTypes;

  if (allowedCategories.includes(category)) {
    router.push({
      name: 'productInvestment',
      params: {
        type: props.categorySelectedProduct,
        id: props.productApiId
      }
    });
  } else {
    router.push({
      name: 'productInvestmentV2',
      params: {
        type: props.categorySelectedProduct,
        id: props.productApiId
      },
      query:
        action === IProductHeroButtonAction.CHOICE
          ? { selection: 'true' }
          : undefined
    });
  }
}

function handleContinueAsClient() {
  isImpersonateEducationalModalOpen.value = false;
  if (pendingAction.value) {
    proceedToInvestment(pendingAction.value);
    pendingAction.value = null;
  }
}

return { __sfc: true,router, props, emit, isButtonLoading, isContinueRegistrationModalOpen, isImpersonateEducationalModalOpen, pendingAction, updateLoading, handleClick, proceedToInvestment, handleContinueAsClient, NebraskaColors, BaseText, ButtonPrimary, ContinueRegistrationModal, ImpersonateEducationalModal }
}

})